<template>
    <section>
        <div v-if="!single" class="is-relative">
            <h3 class="stepper__content__header">{{ $t('RISK_FACTORS') }}</h3>
        </div>

        <steps v-if="!single" :activeStep="1" :steps="10" class="text-xs-center mb-4"></steps>

        <div class="content__wrapper">
            <div class="d-flex align-center">
                <h4 class="stepper__content__title with-description">
                    {{ $t('HEIGHT_AND_WEIGHT') }}
                </h4>
                <div class="description box-shadow box-shadow--arrow-left">
                    {{ $t('PLEASE_INFORMATION_ABOUT_BMI') }}
                </div>
            </div>

            <div class="d-flex flex-row my-3">
                <div class="mt-2">
                    <p>{{ $t('HEIGHT') }}</p>
                    <input
                        :placeholder="measurementSystemIsImperial ? '′' : 'cm'"
                        v-model="userHeightOne"
                        class="el-input__inner mb-2"
                    />
                    <input
                        v-if="measurementSystemIsImperial"
                        placeholder="″"
                        v-model="userHeightTwo"
                        class="el-input__inner mb-2"
                    />
                </div>
                <div class="mt-2">
                    <p>{{ $t('WEIGHT') }}</p>
                    <input
                        :placeholder="measurementSystemIsImperial ? 'lb' : 'kg'"
                        v-model="userWeightOne"
                        class="el-input__inner mb-2"
                    />
                    <input
                        v-if="measurementSystemIsImperial"
                        placeholder="oz"
                        v-model="userWeightTwo"
                        class="el-input__inner mb-2"
                    />
                </div>
                <div class="mt-2">
                    <p>{{ $t('BMI') }}</p>
                    <input disabled v-model="userBMI" class="el-input__inner box-shadow box-shadow--big mb-2" />
                </div>
            </div>

            <div class="text-center">
                <div v-if="single">
                    <button @click.stop="cancel()" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('CANCEL') }}
                    </button>
                    <button
                        v-if="BMIcalculated"
                        @click.stop="save()"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('SAVE') }}
                    </button>

                    <button v-if="!BMIcalculated" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5">
                        {{ $t('SAVE') }}
                    </button>
                </div>

                <div v-else>
                    <button
                        v-if="BMIcalculated"
                        @click.stop="goTo(2)"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('NEXT') }}
                    </button>

                    <button v-if="!BMIcalculated" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5">
                        {{ $t('NEXT') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Steps from './helpers/steps.vue';
import {
    calculateBMI,
    convertFtAndInchesToCentimeters,
    convertLbAndOzToKilos,
    IMPERIAL,
} from '../../../plugins/customSettings';
import { convertCentimetersToImperialUnits, convertKilosToImperialUnits } from 'braster-frontend-utils';

export default {
    created() {
        const userWeight = this.$store.getters.survey.section3.user_weight;
        const userHeight = this.$store.getters.survey.section3.user_height;
        if (this.measurementSystemIsImperial) {
            const imperialWeight = convertKilosToImperialUnits(userWeight);
            this.userWeightOne = imperialWeight.lb > 0 ? imperialWeight.lb : '';
            this.userWeightTwo = imperialWeight.oz > 0 ? imperialWeight.oz : '';
            const imperialHeight = convertCentimetersToImperialUnits(userHeight);
            this.userHeightOne = imperialHeight.ft > 0 ? imperialHeight.ft : '';
            this.userHeightTwo = imperialHeight.inches > 0 ? imperialHeight.inches : '';
        } else {
            this.userWeightOne = userWeight;
            this.userHeightOne = userHeight;
        }
    },
    name: 'survey-step3-q1',
    props: {
        single: Boolean,
    },
    data() {
        return {
            userWeightOne: '',
            userWeightTwo: '',
            userHeightOne: '',
            userHeightTwo: '',
            BMIcalculated: false,
        };
    },
    computed: {
        measurementSystemIsImperial() {
            return this.userTerritory.measurementSystem.name === IMPERIAL;
        },
        userWeightKilos() {
            if (this.measurementSystemIsImperial) {
                return convertLbAndOzToKilos(this.userWeightOne, this.userWeightTwo);
            } else {
                return this.userWeightOne;
            }
        },
        userHeightCentimeters() {
            if (this.measurementSystemIsImperial) {
                return convertFtAndInchesToCentimeters(this.userHeightOne, this.userHeightTwo);
            } else {
                return this.userHeightOne;
            }
        },
        userBMI() {
            const userWeight = this.userWeightKilos;
            const userHeight = this.userHeightCentimeters;
            const bmi = calculateBMI(userWeight, userHeight);
            if (userWeight > 1 && userWeight < 999 && userHeight > 1 && userHeight < 999) {
                if (typeof bmi === 'string' && bmi !== 'NaN') {
                    this.BMIcalculated = true;
                    return bmi;
                }
            }
            this.BMIcalculated = false;
            return 'BMI';
        },
    },
    methods: {
        goTo(id) {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    active_section: id,
                    user_weight: this.userWeightKilos,
                    user_height: this.userHeightCentimeters,
                },
            });
        },
        cancel() {
            this.$emit('cancel');
        },
        save() {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    user_weight: this.userWeightKilos,
                    user_height: this.userHeightCentimeters,
                },
            });
            this.$emit('save');
        },
    },
    components: {
        Steps,
    },
};
</script>



// WEBPACK FOOTER //
// survey-step3-q1.vue?14eddef2